module.exports = __webpack_public_path__ + "static/media/03.223c6260.jpg";